module.exports = __webpack_public_path__ + "static/img/testimony (5).e57cb9f7.jpg";